import { Controller } from "@hotwired/stimulus";

// Generic search submission controller for Go4Stock listings
export default class extends Controller {
  static targets = ["form"];
  static values = { delay: { type: Number, default: 400 } };

  connect() {
    this.form = this.#form();
    this.boundInputHandler = this.#queueSubmit.bind(this);
    this.element.addEventListener("input", this.boundInputHandler);
    this.element.addEventListener("change", this.boundInputHandler);
  }

  disconnect() {
    this.element.removeEventListener("input", this.boundInputHandler);
    this.element.removeEventListener("change", this.boundInputHandler);
    this.#clearTimeout();
  }

  submit(event) {
    event?.preventDefault();
    this.#clearTimeout();
    this.#requestSubmit();
  }

  reset(event) {
    event?.preventDefault();
    const form = this.#form();
    if (!form) return;

    form.reset();
    this.submit();
  }

  #queueSubmit() {
    if (this.delayValue > 0) {
      this.#clearTimeout();
      this.timeout = setTimeout(() => this.#requestSubmit(), this.delayValue);
    } else {
      this.#requestSubmit();
    }
  }

  #requestSubmit() {
    const form = this.#form();
    form?.requestSubmit();
  }

  #clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  #form() {
    if (this.hasFormTarget) return this.formTarget;
    if (this.element.tagName === "FORM") return this.element;
    return this.element.closest("form");
  }
}
